/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/forbid-prop-types */

import React from 'react';
import PropTypes from 'prop-types';
import InputMask from 'react-input-mask';

import { Input, LabelInput } from 'components/Input';

/**
  ## Input with Mask (Label) ##
 */

export const LabelInputMask = (props) => (
  <InputMask
    mask={props.mask}
    value={props.value}
    onChange={props.onChange}
    onBlur={props.onBlur || null}
  >
    {() => <LabelInput {...props} />}
  </InputMask>
);

LabelInputMask.propTypes = {
  props: PropTypes.any.isRequired,
};

/**
  ## Input with Mask (Simple) ##
 */

export const SimpleInputMask = (props) => (
  <InputMask
    mask={props.mask}
    value={props.value}
    onChange={props.onChange}
    onBlur={props.onBlur || null}
  >
    {() => <Input {...props} />}
  </InputMask>
);

SimpleInputMask.propTypes = {
  props: PropTypes.any.isRequired,
};
